import React, { useEffect, useState } from 'react';
import Select, { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

function arrayMove(array, from, to) {
  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
}

const SortableMultiValue = SortableElement((props) => {
  // this prevents the menu from being opened/closed when the user clicks
  // on a value to begin dragging it. ideally, detecting a click (instead of
  // a drag) would still focus the control and toggle the menu, but that
  // requires some magic with refs that are out of scope for this example
  const onMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const innerProps = { ...props.innerProps, onMouseDown };
  return <components.MultiValue {...props} innerProps={innerProps} />;
});

const SortableMultiValueLabel = SortableHandle((props) => <components.MultiValueLabel {...props} />);

const SortableSelect = SortableContainer(Select);
const SortableAsyncSelect = SortableContainer(AsyncSelect);

function MultiSelect({ schema, formData, onChange }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (schema.options?.length || schema.defaultOptions?.length) {
      setOptions(schema.options || schema.defaultOptions);
    }
  }, [schema.options, schema.defaultOptions]);

  const onValueChange = (option) => {
    if (Array.isArray(option)) {
      const newValue = option.length ? option.map((option) => option.value) : '';
      onChange(newValue);
    } else {
      const newValue = option ? option.value : '';
      onChange(newValue);
    }
  };

  let selectedValue;
  if (options && formData) {
    selectedValue = formData.map((value) => options.find((option) => option.value === value));
    selectedValue = selectedValue.filter((value) => value !== null && typeof value !== 'undefined');
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newValue = arrayMove(selectedValue, oldIndex, newIndex);
    onValueChange(newValue);
  };

  return (
    <div>
      <label className="control-label">{schema.title}</label>
      {schema.async ? (
        <SortableAsyncSelect
          useDragHandle
          // react-sortable-hoc props:
          axis="xy"
          onSortEnd={onSortEnd}
          distance={4}
          // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
          getHelperDimensions={({ node }) => node.getBoundingClientRect()}
          // react-select props:
          isMulti
          value={selectedValue}
          onChange={onValueChange}
          components={{
            MultiValue: SortableMultiValue,
            MultiValueLabel: SortableMultiValueLabel,
          }}
          closeMenuOnSelect={false}
          loadOptions={(input) =>
            schema.loadOptions(input, formData).then((newOptions) => {
              setOptions(newOptions);
              return newOptions;
            })
          }
          defaultOptions={schema.defaultOptions}
        />
      ) : (
        <SortableSelect
          useDragHandle
          // react-sortable-hoc props:
          axis="xy"
          onSortEnd={onSortEnd}
          distance={4}
          // small fix for https://github.com/clauderic/react-sortable-hoc/pull/352:
          getHelperDimensions={({ node }) => node.getBoundingClientRect()}
          // react-select props:
          isMulti
          options={options}
          value={selectedValue}
          onChange={onValueChange}
          components={{
            MultiValue: SortableMultiValue,
            MultiValueLabel: SortableMultiValueLabel,
          }}
          closeMenuOnSelect={false}
        />
      )}
    </div>
  );
}

export default MultiSelect;
